/** @jsx h */
import { h } from 'preact'
import Arrow from '../claims/icons/Arrow'

const PollOrganization = ({ name, avatarUrl, href }) => (
  <div class='Poll-organization'>
    <img
      alt={name}
      class='Poll-avatar is-lazyLoad'
      data-src={avatarUrl}
      height='120'
      width='120'
    />
    <p class='Poll-orgLabel'>Organisation</p>
    <div class='Poll-orgName'>{name}</div>
    <a
      href={href}
      class='Action Action--transformNone Action--inline Action--minimal u-marginTop8'
    >
      View profile on Provenance.org <Arrow />
    </a>
  </div>
)

export default PollOrganization
